import { h } from 'preact';
import Store from 'store/store';
import * as BaseComp from 'components/bolt/showtimes/quickFilters.js';
import s from 'components/bolt/showtimes/quickFilters.sss';

import { joinClasses } from 'utils/utils';
import { getShowtimesData } from 'utils/bolt';
import { getMovieName } from 'utils/bolt/showtimes';
import { getQuickFilterOptions } from 'utils/bolt/quickFilters';
import { generateLanguageLabel } from 'utils/bolt/screeningAttributes';

import ScrollBox from 'components/shared/scrollBox/scrollBox';

import ArrowDown from 'components/bolt/icons/arrowDown';
import Chevron from 'components/bolt/icons/chevron';

export default class QuickFilters extends BaseComp.default {

	constructor(props) {
		super(props);

		this.state = {
			numBubbles: 0,
			scrollPosition: 0,
			totalWidth: 0,
		};

		this.showtimesAppData = getShowtimesData() || {};
		this.quickFiltersData = this.showtimesAppData.quickFilters || {};
		this.arrowCTAAnimation = this.quickFiltersData?.arrowCTAAnimation || null;

		this.isActive = this.isActive.bind(this);
	}


	renderBubbles(title) {
		const isDesktop = Store.get().client.isDesktopSize;
		const possibleOptions = getQuickFilterOptions(this.props.possibleOptions);
		const allOption = {
			name: this.props?.appData?.copy?.baseCopy?.$ALL || 'All',
			value: 'all',
		};
		const allowedFilters = [allOption].concat(
			possibleOptions.flatMap((option) => {
				if (option.name === 'movie' && option.allowedValues?.[0]?.toLowerCase() === 'all') {
					const allMovieIds = this.props.filters?.available?.movie || [];
					option.allowedValues = this.sortMovies(allMovieIds);
				}

				if (option.name === 'combinedLanguage') {
					let combinedLanguageValues = option.allowedValues?.filter((val) => {
						return Object.keys(val).every((key) => this.props.filters.available[key]?.includes(val[key]));
					});
					return combinedLanguageValues.map((value) => ({ name: 'combinedLanguage', value }));
				}

				let values = this.props.filters.available[option.name];
				if (!values) {
					return [];
				}
				if (option.allowedValues) {
					values = option.allowedValues.filter((x) => values.includes(x));
				}
				return values.map((value) => ({ name: option.name, value }));
			})
		);

		const showtimesAppData = getShowtimesData() || {};

		const bubbles = allowedFilters?.map((filter) => {
			const { name, value } = filter;
			let label = value;
			const baseCopy = this.props?.appData?.copy?.baseCopy || {};
			const filtersCopy = baseCopy.filters || {};
			const languagesCopy = baseCopy.languages || {};
			if (name === 'combinedLanguage') {
				label = generateLanguageLabel(value);
			} else if (name === 'originalLanguage') {
				label = baseCopy.$ORIGINAL_LANGUAGE;
			} else if (name === 'subtitles') {
				label = baseCopy.$LANGUAGE_SUB;
			} else if (name === 'dubbing') {
				label = baseCopy.$LANGUAGE_DUB;
			} else if (name === 'overVoice') {
				label = baseCopy.$LANGUAGE_OV;
			} else if (name === 'movie') {
				label = showtimesAppData.movieData?.[value]?.quickFilterBubble || getMovieName(value);
			} else if (value === 'all') {
				label = name;
			} else {
				label = filtersCopy[name]?.[value];
			}

			label = label ? label.replace('<lang>', languagesCopy[value]) : value;

			return (
				<button
					key={`${name}-${value}`}
					id={value}
					onClick={() => {
						this.updateFilters(name, value);
						this.scrollBubbleIntoView(value);
					}}
					className={joinClasses(s.bubble, this.isActive(filter, allowedFilters) && s.active)}
				>
					{label}
				</button>
			);
		});

		if (title) {
			bubbles.unshift(
				<div className={joinClasses(s.title)}>
					<span>
						{!this.arrowCTAAnimation ? title : this.renderScrollArrowCTA()}
					</span>
				</div>
			);
		}

		if (bubbles.length !== this.state.numBubbles) {
			this.setState({ numBubbles: bubbles.length });
		}

		return (
			<div className={s.bubbles} ref={($ref) => (this.$bubbles = $ref)}>
				{bubbles}
			</div>
		);
	}

	renderScrollArrowCTA() {
		const isDesktop = Store.get().client.isDesktopSize;

		return (
			<div class={joinClasses(s.scrollDownCTA)}>
				<span>{isDesktop ? this.arrowCTAAnimation.desktopCTA : this.arrowCTAAnimation.mobileCTA}</span>
				<ArrowDown class={s.arrow} />
			</div>
		);
	}

	render() {
		const { isRTL, isSticky, title, wrappedView } = this.props;
		const isDesktop = Store.get().client.isDesktopSize;

		return (
			<div className={joinClasses(s.container, isSticky && s.sticky, wrappedView && s.wrappedView, isDesktop && s.buttonsEnabled)} ref={(e) => (this.$container = e)}>
				{isDesktop && (
					<div className={joinClasses(s.arrowButtonsContainer)}>
						<button className={s.leftArrowButton} onClick={this.scrollLeft}>
							<Chevron />
						</button>
						<button className={s.rightArrowButton} onClick={this.scrollRight}>
							<Chevron />
						</button>
					</div>
				)}
				<ScrollBox
					class={joinClasses(s.scrollBoxContainer)}
					device="mobile"
					tabIndex="0"
					onKeyDown={this.filtersKeyDown}
					ref={(e) => (this.$scrollBox = e)}
					hideScrollerBar
					isRTL={isRTL}
				>
					<div className={s.bubbles} ref={($ref) => (this.$bubbles = $ref)} style={{ transform: `translateX(${-this.state.scrollPosition}px)` }}>
						{this.renderBubbles(title)}
					</div>
				</ScrollBox>
			</div>
		);
	}
}
